import { Button, Col, Form, Input, Row, Select } from "antd";
import { getModifiedResponse } from "../../../global/utils/responseModifier";
import useGet from "../../../global/hooks/useGet";
import CustomDateTimePicker from "../../../global/components/inputWidgets/CustomDatePicker";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { HiArrowPath } from "react-icons/hi2";
import { ordertypeOptions } from "../../../utils/Common";
import dayjs from "dayjs";
import { useEffect } from "react";

export const OrderFilter = ({
  filter,
  handleFilterChange,
  handleFilter,
  handleReset,
  setFilter,
  params,
  onSiteRegReport,
}) => {
  const [form] = Form.useForm();
  const modParams = { ...Object.fromEntries([...params?.entries()]) } || {}; //

  const handleFormChange = (changedValues, allValues) => {
    // Update filter state when form values change
    Object.keys(changedValues).forEach((key) => {
      if (key === "Month") {
        const formattedMonth = changedValues[key]
          ? dayjs(changedValues[key]).format("YYYY-MM")
          : null;
        setFilter({ ...filter, Month: formattedMonth });
      } else if (key === "OrderTime") {
        setFilter({ ...filter, OrderTime: changedValues[key] });
      }
    });
  };

  useEffect(() => {
    const formValues = {};

    if (modParams?.Month) {
      formValues.Month = dayjs(modParams.Month, "YYYY-MM");
    }

    if (modParams?.OrderTime) {
      formValues.OrderTime = dayjs.unix(Number(modParams.OrderTime));
    }

    // Set form values without triggering onChange
    if (Object.keys(formValues).length > 0) {
      form.setFieldsValue(formValues);
    }
  }, [params]);

  const optionCodesUrl = `${process.env.REACT_APP_API_URL}/api/licensecodes/getoptions/`;
  const licenseCodesUrl = `${process.env.REACT_APP_API_URL}/api/licensecodes/codes/?limit=0&Item=${filter?.Item || ""}`;

  const {
    data: licenseCodesData,
    loading: licenseCodesDataLoading,
    error: licenseCodesDataError,
  } = useGet(licenseCodesUrl);

  const { data: optionCodesData } = useGet(optionCodesUrl);

  const modifiedItems = getModifiedResponse(optionCodesData, "items");
  // const modifiedOems = getModifiedResponse(optionData, "oems");
  // const modifiedDealer = getModifiedResponse(dealerOptions, null);
  // const modifiedCustomers = getModifiedResponse(custmerOptions, null);

  return (
    <Form className="" form={form} onValuesChange={handleFormChange}>
      <div className="mt-2">
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={24} md={12} lg={6} xl={6}>
            <Input
              className="input_text_3 mr10 !h-full"
              name="DeviceNo"
              placeholder="No"
              value={filter.DeviceNo}
              onChange={(e) => {
                const { value } = e.target;
                // Allow only positive integers or empty string
                if (/^[0-9]\d*$/.test(value) || value === "") {
                  handleFilterChange(e);
                }
              }}
              onKeyDown={(e) => {
                // Prevent 'e', 'E', '+', '-' keys
                const blockedKeys = ["e", "E", "+", "-", "."];
                if (blockedKeys.includes(e.key)) {
                  e.preventDefault();
                }
                if (/^[0-9]$/.test(e.key)) {
                  const input = e.target;
                  const { selectionStart, selectionEnd, value } = input;
                  const nextValue =
                    value.slice(0, selectionStart) +
                    e.key +
                    value.slice(selectionEnd);

                  if (!/^(0|[1-9]\d*)$/.test(nextValue)) {
                    e.preventDefault();
                  }
                }
              }}
            />
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={6}>
            <CustomDateTimePicker
              name="OrderTime"
              placeholder="Order Time"
              format="YYYY-MM-DD HH:mm" // 24-hour format
            />
          </Col>
          {/* {hasRole(1, 2, 3) ? (
            <Col xs={24} sm={24} md={12} lg={8} xl={6}>
              <Select
                showSearch
                placeholder="OEM"
                optionFilterProp="label"
                value={
                  filter.OemNo || typeof filter.OemNo === "number"
                    ? Number(filter.OemNo)
                    : null
                }
                onChange={(value) => setFilter({ ...filter, OemNo: value })}
                options={modifiedOems}
                style={{ width: "100%" }}
                allowClear
              />
            </Col>
          ) : (
            <></>
          )}
          {hasRole(1, 2, 3, 4, 5, 6) ? (
            <Col xs={24} sm={24} md={12} lg={8} xl={6}>
              <Select
                showSearch
                placeholder="Dealer"
                optionFilterProp="label"
                value={filter.DealerNo ? Number(filter.DealerNo) : undefined}
                onChange={(value) => setFilter({ ...filter, DealerNo: value })}
                options={modifiedDealer}
                style={{ width: "100%" }}
                allowClear
                disabled={
                  hasRole(4, 5, 6)
                    ? false
                    : filter.OemNo === undefined ||
                      filter.OemNo === null ||
                      filter.OemNo === ""
                }
              />
            </Col>
          ) : (
            <></>
          )}
          {!hasRole(9, 10, 11, 12) ? (
            <Col xs={24} sm={24} md={12} lg={8} xl={6}>
              <Select
                showSearch
                placeholder="Customer"
                optionFilterProp="label"
                value={
                  filter.CustomerNo ? Number(filter?.CustomerNo) : undefined
                }
                onChange={(value) =>
                  setFilter({ ...filter, CustomerNo: value })
                }
                options={modifiedCustomers}
                style={{ width: "100%" }}
                allowClear
                disabled={
                  hasRole(7, 8, 9)
                    ? false
                    : filter.DealerNo === undefined ||
                      filter.DealerNo === null ||
                      filter.DealerNo === ""
                }
              />
            </Col>
          ) : (
            <></>
          )} */}
          <Col xs={24} sm={24} md={12} lg={8} xl={6}>
            <Select
              showSearch
              placeholder="Order Type"
              optionFilterProp="label"
              value={
                typeof filter.OrderType === "number"
                  ? Number(filter.OrderType)
                  : undefined
              }
              onChange={(value) => setFilter({ ...filter, OrderType: value })}
              options={ordertypeOptions}
              style={{ width: "100%" }}
            />
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={6} className="!h-[32px]">
            <Input
              className="input_text_3 mr10 !h-full"
              name="Mac"
              placeholder="MAC"
              value={filter.Mac}
              onChange={handleFilterChange}
            />
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={6}>
            <Select
              showSearch
              placeholder="License Item"
              optionFilterProp="label"
              value={
                typeof filter.Item === "number"
                  ? Number(filter.Item)
                  : undefined
              }
              onChange={(value) => setFilter({ ...filter, Item: value })}
              options={modifiedItems}
              style={{ width: "100%" }}
            />
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={6}>
            <Select
              showSearch
              placeholder="License Code"
              optionFilterProp="label"
              value={
                typeof filter.Code === "number"
                  ? Number(filter.Code)
                  : undefined
              }
              onChange={(value) => setFilter({ ...filter, Code: value })}
              options={licenseCodesData}
              style={{ width: "100%" }}
            />
          </Col>
          {/* <Col xs={24} sm={24} md={12} lg={8} xl={6}>
            <Select
              showSearch
              placeholder="Free"
              optionFilterProp="label"
              value={
                filter.Free || filter.Free === 0
                  ? Number(filter.Free)
                  : undefined
              }
              onChange={(value) => setFilter({ ...filter, Free: value })}
              options={booleanOptions}
              style={{ width: "100%" }}
            />
          </Col> */}
        </Row>
      </div>
      <div className="w-full overflow-x-auto">
        <div className="flex justify-between my-4 flex-nowrap min-w-[610px]">
          <div className="flex items-center">
            <Button
              type="primary"
              className="mr-2 w-[104px] h-[30px] font-medium"
              onClick={handleFilter}
            >
              <IoIosCheckmarkCircleOutline className="!text-[14px] font-medium" />
              Apply
            </Button>
            <Button
              className="reset-button !mr-2"
              onClick={() => {
                form.resetFields();
                handleReset();
              }}
            >
              <HiArrowPath className="!text-[14px] font-medium" />
              Reset
            </Button>
            {/* <Button
              type="primary"
              className="w-[220px] h-[30px] font-medium"
              onClick={onSiteRegReport}
            >
              <FaFileAlt className="!text-[14px] font-medium" />
              On Site Registration Report
            </Button> */}
          </div>
        </div>
      </div>
    </Form>
  );
};
